// left menu icons
import selling from './selling.svg';
import learning from './learning.svg';
import manuals from './manuals.svg';
import parts from './parts.svg';
import marketing from './marketing.svg';
import forum from './forum.svg';
import binconfig from './binconfig.svg';
import register from './register.svg';
import tools from './tools.svg';
import warranty from './warranty.svg';
import home from './home.svg';

/**
 * Imported as symbols
 */
export {
  selling,
  learning,
  manuals,
  parts,
  marketing,
  forum,
  binconfig,
  register,
  tools,
  warranty,
  home
};



// WEBPACK FOOTER //
// ./src/images/symbols/index.js